import React, { Component } from "react";
import PropTypes from "prop-types";

import { Link as ReactRouterLink } from "react-router-dom";
import Image from "../../../image/image";
import classNames from "classnames";
import SimpleDesignLinkButton from "../../../../simple-design/simple-design-link-button";
import DashedCorners from "@default/general-components/dashed-corners";

const ClickSuggestion = ({ content }) => {
  const articleClassNames = classNames({
    "click-suggestion": true,
    "with-image": content?.fieldImage,
    "no-image": !content?.fieldImage,
    highlighted: content?.fieldHighlighted,
  });

  return (
    <article className={articleClassNames}>
      <div className="inner-wrapper">
        <DashedCorners modifier={"bigger"} />
        <div className="content-wrapper">
          {content.fieldImage && (
            <div className="background-image">
              <Image
                data={content.fieldImage.fieldMediaImage}
                credit={content.fieldImage.fieldCredits}
              />
            </div>
          )}
          <div className="text-wrapper">
            <span className="headline body-m">
              {content?.fieldHeading ? (
                <>{content.fieldHeading}</>
              ) : (
                <>
                  {content?.fieldLink?.title && <>{content.fieldLink?.title}</>}
                </>
              )}
            </span>
            <span className="subline body-m">{content.fieldSubline}</span>

            <SimpleDesignLinkButton tabIndex={-1} />
          </div>
        </div>
      </div>
    </article>
  );
};

ClickSuggestion.propTypes = {
  content: PropTypes.shape({
    fieldHeading: PropTypes.string,
    fieldSubline: PropTypes.string,
    fieldImage: PropTypes.object,
    fieldLink: PropTypes.shape({
      url: PropTypes.shape({
        routed: PropTypes.bool,
        path: PropTypes.string,
      }),
    }),
  }),
};

export default ClickSuggestion;
